import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext, useEffect, useState } from 'react';
import TripRateCalculationFiltersViewModel from '../../TripRate/ViewModels/TripRateCalculationFiltersViewModel';
import TripRateParamerterDescriptionViewModel from '../../TripRate/ViewModels/TripRateParamerterDescriptionViewModel';
import AnalysisFilterViewModel from '../ViewModels/AnalysisFilterViewModel';
import { APIContext } from '../../Contexts/APIContext';
import PrimaryFiltersViewModel from '../../TripRate/ViewModels/PrimaryFiltersViewModel';
import LandUsePageViewModel from '../../TripRate/ViewModels/TripRateFilterViewModel';
import HelpLink from '../../Popups/HelpLink';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function TripRateParameters({ state, updateState }: IProps) {
    const [tripRateParameters, setTripRateParameters] = useState<TripRateParamerterDescriptionViewModel[]>([]);
    const { post, showMessage, version } = useContext(APIContext);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        updateTripRateParams();
    }, []);

    useEffect(() => {
        updateTripRateParams();
    }, [state.landUseMain, state.landUseSub, state.startYear, state.endYear, version]);

    useEffect(() => {
        if (tripRateParameters && tripRateParameters.length - 1 >= state.tripRateParamHeaderIndex) {
            updateState({ tripRateParamName: tripRateParameters[state.tripRateParamHeaderIndex]?.name })
        }
    }, [tripRateParameters, state.tripRateParamHeaderIndex])

    const updateTripRateParams = () => {
        if (state.landUseMain && state.landUseSub) {
            setLoading(true);

            const vm = new TripRateCalculationFiltersViewModel();

            vm.tripRateMain = state.landUseMain;
            vm.tripRateSub = state.landUseSub;
            vm.primaryFilters = new PrimaryFiltersViewModel();
            vm.primaryFilters.startDate = new Date(state.startYear, 0, 1);
            vm.primaryFilters.endDate = new Date(state.endYear, 11, 31);
            vm.secondaryFilters = null;
            vm.landUsePage = new LandUsePageViewModel();

            post(
                "TripRateFilter",
                "GetTripRateParameters",
                vm,
                (response: TripRateParamerterDescriptionViewModel[] | null | undefined) => {
                    setLoading(false);

                    if (Array.isArray(response)) {
                        setTripRateParameters(response);
                        if (response[state.tripRateParamHeaderIndex].disabled) {
                            showMessage('warning', "Trip Rate calculations for this land use are currently unavailable but will become available again shortly. We do apologise for any inconvenience and please email support@trics.org if you imminently need to carry out a trip rate calculation for this land use.")
                        }
                    } else {
                        setTripRateParameters([]);
                    }
                }
            );
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var headerIndex = Number.parseInt((event.target as HTMLInputElement).value)

        updateState({
            tripRateParamHeaderIndex: headerIndex,
            tripRateParamName: tripRateParameters[headerIndex].name
        })
    }

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Typography>Trip Rate Parameters</Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" width="100%" padding={2}>
                    <CircularProgress />
                </Box>
            ) : (
                    <>
                        <Grid size={11}>
                            <RadioGroup onChange={handleChange} value={ state.tripRateParamHeaderIndex }>
                                {tripRateParameters.map((param, index) => {
                                    if (!param.name) {
                                        return (
                                            <div key={index} style={{ height: '40px' }} />
                                        );
                                    }

                                    return (
                                        <FormControlLabel
                                            key={index}
                                            value={index}
                                            control={<Radio />}
                                            label={`${param.name} ${param.count}`}
                                        />
                                    );
                                })}
                            </RadioGroup>
                        </Grid>
                        <Grid size={1}>
                            <HelpLink page="Definitions of trip rate parameters" />
                        </Grid>
                </>
            )}
        </Grid>
    )
}
